import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    matrixContainer: {
        paddingTop: theme.spacing(2),
    },
    matrixVerticalHeader: {
        position: 'relative',
        height: '160px !important',
        marginTop: '8px',
        borderBottom: '1px solid transparent',
        overflow: 'visible !important',
        verticalAlign: 'bottom',
        whiteSpace: 'nowrap',
        transformOrigin: '81px',
        transform: 'rotate(-90deg)',
    },
    matrixRotateHeader: {
        position: 'relative',
        borderBottom: '1px solid transparent',
        whiteSpace: 'nowrap !important',
        transformOrigin: 'bottom left',
        transform: 'translateX(27px) rotate(-55deg)',
        overflowX: 'visible !important',
        overflowY: 'visible !important',
        verticalAlign: 'bottom',
        padding: '0px !important',
        '& div': {
            position: 'absolute',
            bottom: 0,
        },
    },
    matrixNormalHeader: {
        position: 'relative',
        borderBottom: '1px solid transparent',
        textAlign: 'right',
        lineHeight: 1,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        height: '41px !important',
    },
    matrixFirstCell: {
        textAlign: 'right',
        borderBottom: '1px solid transparent',
    },
    matrixTestTypeCell: {
        borderBottom: '1px solid transparent',
        '& .material-icons': {
            fontSize: '14px',
        },
    },
    matrixDataCell: {
        borderBottom: '1px solid transparent',
    },
}));

export default useStyles;
